import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { debounce } from "lodash";
import UploadButton from "../../components/UploadButton";
import { Toolbar, ToolbarGroup } from "../../components/Toolbar";
import { imagesList, uploadImage, openModal } from "../../actions";
import { history } from "../../history";

export class ListImageToolbar extends Component {
  constructor(props) {
    super(props);
    this.openCreateModal = this.openCreateModal.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.search = debounce(this.search.bind(this), 300);
    this.uploadFile = this.uploadFile.bind(this);
    this.searchRef = createRef();
  }

  componentDidMount() {
    if (this.searchRef?.current) {
      this.searchRef.current.focus();
      this.searchRef.current.selectionStart =
        this.searchRef.current.selectionEnd =
          this.searchRef.current.value.length;
    }
  }

  onSearch(e) {
    const searchTerm = e.currentTarget.value;
    this.search(searchTerm);
  }

  search(searchTerm) {
    this.props.imagesList(
      this.props.accountId,
      {
        name: searchTerm,
      },
      true
    );
    history.push(
      `${window.location.pathname}?name=${encodeURIComponent(searchTerm)}`
    );
  }

  openCreateModal() {
    const { accountId } = this.props;

    this.props.openModal("create-email", {
      accountId,
    });
  }

  uploadFile(e) {
    var file = e.currentTarget.files[0];
    this.props.uploadImage(this.props.accountId, file).then(() => {
      this.props.imagesList(this.props.accountId, null, true);
    });
  }

  render() {
    const { searchTerm } = this.props;

    return (
      <Toolbar>
        <ToolbarGroup>
          <input
            ref={this.searchRef}
            placeholder="Search"
            style={{ width: "100%" }}
            onChange={this.onSearch}
            defaultValue={searchTerm}
          />
        </ToolbarGroup>
        <ToolbarGroup width="100" align="right">
          <UploadButton onChange={this.uploadFile}>Upload</UploadButton>
        </ToolbarGroup>
      </Toolbar>
    );
  }
}

ListImageToolbar.propTypes = {
  openModal: PropTypes.func.isRequired,
};

// Connect actions
export default connect(null, {
  openModal,
  imagesList,
  uploadImage,
})(ListImageToolbar);
